export const designTokens = {
  colors: {
    page: "#1a1a1d",
    pageAlt: "#141416",
    surface: "#2a2a2e",
    border: "rgb(68 64 60)",
  },
  radii: {
    card: "rounded-xl",
    feature: "rounded-2xl",
  },
};

export const layoutClasses = {
  appShell: "min-h-screen flex flex-col bg-[#1a1a1d]",
  pageShell: "min-h-screen bg-[#1a1a1d]",
  adminShell: "min-h-screen bg-[#1a1a1d]",
  container: "max-w-7xl mx-auto px-4 sm:px-6 lg:px-8",
  narrowContainer: "max-w-4xl mx-auto px-4 sm:px-6 lg:px-8",
  section: "py-16 md:py-20 bg-[#1a1a1d]",
  sectionLarge: "py-20 md:py-28 bg-[#1a1a1d]",
  sectionAlt: "py-16 md:py-20 bg-[#141416]",
  pageHero: "bg-gradient-to-b from-[#1a1a1d] to-[#141416] py-16 md:py-24",
};

export const surfaceClasses = {
  card: "bg-[#2a2a2e] border-stone-700",
  cardInteractive: "bg-[#2a2a2e] border-stone-700 hover:border-rose-500/50 transition-all duration-300",
  header: "z-50 bg-transparent",
  footer: "bg-[#141416] border-t border-stone-800",
  adminSidebar: "bg-[#141416] border-stone-800",
};

export const actionClasses = {
  primary:
    "bg-[#F5BCB1] hover:bg-[#efaaa0] text-stone-900 border-0 shadow-lg shadow-[#F5BCB1]/25",
  primaryStrong:
    "bg-[#F5BCB1] hover:bg-[#efaaa0] text-stone-900 border-0 shadow-xl shadow-[#F5BCB1]/25",
  outlineDark:
    "border-stone-600 text-stone-200 hover:bg-stone-800 hover:text-white",
};

export const iconTileClasses = {
  rose: "rounded-2xl bg-gradient-to-br from-rose-500/20 to-pink-500/10 flex items-center justify-center",
};
